import { render } from "./CoffeeShopCard.vue?vue&type=template&id=5bbfb8be&scoped=true"
import script from "./CoffeeShopCard.vue?vue&type=script&lang=js"
export * from "./CoffeeShopCard.vue?vue&type=script&lang=js"

import "./CoffeeShopCard.vue?vue&type=style&index=0&id=5bbfb8be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbfb8be"]])

export default __exports__